import { get, set } from "es-toolkit/compat";

import type { MultilingualNodeConfig } from "../../schemas/index.ts";
import { enableMultilingualOnProperty } from "./enableMultilingualOnProperty.ts";
import { isMultilingualProperty } from "./filterFunctions.ts";

interface Options {
  getAvailableProperties: (typeId: string) => { required: string[]; optional: string[] } | undefined;
  lang: string;
}

export const ensureMultilingualPropertiesCreate =
  ({ getAvailableProperties, lang }: Options) =>
  (typeId: string, config: MultilingualNodeConfig) => {
    const availableProperties = getAvailableProperties(typeId);
    if (!availableProperties) return config;

    const { required } = availableProperties;
    if (required.length === 0) return config;

    let newConfig: MultilingualNodeConfig | undefined;
    for (const name of required) {
      const value = get(config, name);
      if (value === undefined || isMultilingualProperty(value)) {
        continue;
      }
      if (!newConfig) {
        newConfig = structuredClone(config);
      }
      if (Array.isArray(value)) {
        throw new Error(
          `Multilingual properties cannot be arrays: Found property "${name}" on node of typeId "${typeId}".`,
        );
      }

      set(newConfig, name, enableMultilingualOnProperty(value, lang));
    }
    return newConfig ?? config;
  };

export type EnsureMultilingualProperties = ReturnType<typeof ensureMultilingualPropertiesCreate>;
